export { default } from './splash';
